import { BackwardOutlined } from '@ant-design/icons'
import ReactDOM from 'react-dom/client'
import { Root } from 'react-dom/client'
import videojs from 'video.js'
import Player from 'video.js/dist/types/player'
import styles from '../VideoPlayer.module.less'
import { SEEK_INTERVAL } from './constants'

export class BackwardButton extends videojs.getComponent('Button') {
    private reactRoot: Root | null = null

    constructor(player: Player, options: object) {
        super(player, options)
        // @ts-ignore
        this.controlText(`Backward ${SEEK_INTERVAL}s`)
    }

    handleClick() {
        const player = this.player()
        const currentTime = player.currentTime() ?? 0
        // @ts-ignore
        const segment = player.segment_ || null

        if (segment && segment.startTime !== undefined) {
            const newTime = Math.max(segment.startTime, currentTime - SEEK_INTERVAL)
            player.currentTime(newTime)
        } else {
            player.currentTime(Math.max(0, currentTime - SEEK_INTERVAL))
        }
    }

    createEl() {
        const el = super.createEl()
        this.reactRoot = ReactDOM.createRoot(el)
        const renderNode = (
            <div className={styles['vjs-custom-button']}>
                <BackwardOutlined />
            </div>
        )
        this.reactRoot.render(renderNode)
        return el
    }

    dispose() {
        if (this.reactRoot) {
            this.reactRoot.unmount()
            this.reactRoot = null
        }
        super.dispose()
    }
}
